import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, Suspense, lazy } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import routes from "../routes";
import { t } from "i18next";
import { useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Main from "../containers/Main";
import ThemedSuspense from "../components/ThemedSuspense";
import { SidebarContext } from "../context/SidebarContext";
import ErrorModal from "../components/Modals/ErrorModal";
import { AuthContext } from "../context/AuthContext";
import { useTheme } from "../context/ThemeContext";
import { roleName } from "../constants_map";
import { handleHelpClick } from "./helpers";
import HelpButton from "components/Button/HelpButton";
var Page404 = lazy(function () { return import("../pages/404"); });
function Layout() {
    var isSidebarOpen = useContext(SidebarContext).isSidebarOpen;
    var _a = useContext(AuthContext), showSessionExpiredModal = _a.showSessionExpiredModal, setShowSessionExpiredModal = _a.setShowSessionExpiredModal, logout = _a.logout, userRole = _a.userRole, collapsed = _a.collapsed, loggedInRole = _a.loggedInRole;
    var theme = useTheme().theme;
    var location = useLocation();
    var isStudioModule = location.pathname.includes("/app/studio/");
    var errorModal = function () {
        logout();
        setShowSessionExpiredModal(false);
    };
    /**
     * In Help button Global User and Platform Admin are treated as same role.
     * This is because Global User has the same access as Platform Admin.
     * So, we are using Platform Admin for both roles in the Help button.
     */
    // const loggedInRole =
    //   userRole === roleName.enterpriseAdmin
    //     ? "EA"
    //     : userRole === roleName.enterpriseUser
    //     ? "EU"
    //     : userRole === roleName.platformAdmin
    //     ? "PA"
    //     : userRole === roleName.globalUser
    //     ? "PA"
    //     : "NA";
    var handleHelp = function () {
        console.log("[INFO] User role: \"".concat(userRole, "\", roleName: "), roleName);
        handleHelpClick(location.pathname, loggedInRole);
    };
    var shouldShowHelpButton = location.pathname !== "/app/home" &&
        location.pathname !== "/app/billing-pricing/invoicing" &&
        location.pathname !== "/app/policy/dnd/msisdn/upload" &&
        location.pathname !== "/app/policy/QuietTime/_add" &&
        location.pathname !== "/app/Routing/SMS/_create";
    return (_jsxs("div", { className: "h-full", style: {
            fontFamily: theme.font,
        }, children: [_jsx(Header, {}), _jsxs("div", { className: "flex flex-row h-min lg:relative ".concat(isSidebarOpen ? "overflow-hidden" : ""), style: {
                    height: "calc(100% - 64px)",
                }, children: [_jsx("div", { className: "lg:fixed lg:z-10 z-auto", children: _jsx(Sidebar, {}) }), _jsx("div", { className: "flex flex-col flex-1 w-full transition-all duration-300 ease-in-out h-full ".concat(collapsed
                            ? "lg:ltr:ml-[70px] lg:rtl:mr-[70px]"
                            : "lg:ltr:ml-[221px] lg:rtl:mr-[221px]"), children: _jsx(Main, { children: _jsx(Suspense, { fallback: _jsx(ThemedSuspense, {}), children: _jsxs(Routes, { children: [routes.map(function (route, i) {
                                            return route.component ? (_jsx(Route, { path: "".concat(route.path), element: _jsx(route.component, {}) }, i)) : null;
                                        }), _jsx(Route, { path: "/app", element: _jsx(Navigate, { to: "/app/home" }) }), _jsx(Route, { path: "*", element: _jsx(Page404, {}) })] }) }) }) }), shouldShowHelpButton && _jsx(HelpButton, { onClick: handleHelp })] }), _jsx(ErrorModal, { errorModal: showSessionExpiredModal, deleteError: t("_Session_expired._Please_login_again."), setErrorModal: errorModal, buttonTxt: "Log In" })] }));
}
export default Layout;
